import {NgModule} from '@angular/core';

import { SafeHtmlPipe } from './safe-html.pipe';
import { JalaliConvertorPipe } from './jalali-convertor.pipe';
import { PersianCurrencyPipe } from './persian-currency.pipe';
import {PersianDatePipe} from './persian-date.pipe';
import {PayaStatusPipe} from './paya-status.pipe';

@NgModule({
  declarations: [
    SafeHtmlPipe,
    JalaliConvertorPipe,
    PersianCurrencyPipe,
    PersianDatePipe,
    PayaStatusPipe
  ],
  imports: [],
  exports: [
    SafeHtmlPipe,
    JalaliConvertorPipe,
    PersianCurrencyPipe,
    PersianDatePipe,
    PayaStatusPipe
  ]
})
export class PipesModule { }
